import BaseDataSelect from './BaseDataSelect.vue';
import baseDataMixin from './mixin';

export { baseDataMixin };
export default BaseDataSelect;
